<!-- SleepReportDetail.vue -->
<template>
    <div>
        <el-dialog :title="title" :visible.sync="isDialog" width="75%" append-to-body @close="handleCancel">
            <div class="detail-container">
                <h2>睡眠报告详情</h2>
                <!-- <div class="time">
                    <el-form :inline="true" :model="searchForm" size="mini" label-width="100px"
                        class="demo-form-inline">
                        <el-form-item label="日期选择:">
                            <el-date-picker v-model="time" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div> -->
                <div class="flex">
                    <div class="part">
                        <div class="title">睡眠时间</div>
                        <!-- 主体内容 -->
                        <div class="content">
                            <!-- 左侧信息 -->
                            <div class="left-info">
                                <div class="info-item">
                                    <!-- <div class="icon"><i class="el-icon-bed"></i></div> -->
                                    <div class="text">上床时间</div>
                                    <div class="value">{{ sleepDetailVO.gotobedTime }}</div>
                                </div>
                                <div class="info-item">
                                    <!-- <div class="icon"><i class="el-icon-s-custom"></i></div> -->
                                    <div class="text">起床时间</div>
                                    <div class="value">{{ sleepDetailVO.getoffbedTime }}</div>
                                </div>
                            </div>
                            <!-- 中间图表区域 -->
                            <div class="chart-container">
                                <div ref="chart1" id="chart1" style="width:100%;height:200px"></div>
                            </div>
                            <!-- 右侧信息 -->
                            <div class="right-info">
                                <div class="info-item">
                                    <!-- <div class="icon"><i class="el-icon-clock"></i></div> -->
                                    <div class="text">卧床时长</div>
                                    <div class="value">{{ sleepDetailVO.bedDuration }}分钟</div>
                                </div>
                                <div class="info-item">
                                    <!-- <div class="icon"><i class="el-icon-moon"></i></div> -->
                                    <div class="text">睡眠时长</div>
                                    <div class="value">{{ sleepDetailVO.sleepDuration }}分钟</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="part marL">
                        <div class="title">睡眠分期</div>
                        <div class="sleep-chart-container"
                            v-if="sleepDetailVO.sleepStages && sleepDetailVO.sleepStages.length > 0">
                            <div ref="chart2" id="chart2" style="width:100%;height:200px"></div>
                        </div>
                        <div v-else class="nodata"> 暂无数据</div>
                    </div>
                </div>
                <div class="flex">
                    <div class="part">
                        <div class="flex">
                            <div class="title">睡眠分析</div>
                            <div class="quity">{{ sleepDetailVO.sleepQualityDesc }}</div>
                        </div>
                        <div class="chart-container">
                            <div ref="chart3" id="chart3" style="width:100%;height:200px;" v-if="hasSleepData"></div>
                            <div v-else class="nodata" style="margin:30px 0"> 暂无数据</div>
                        </div>
                        <div class="sleep-stats-container">
                            <div class="stats-item">
                                <div class="label">睡眠准备期 </div>
                                <div class="value">{{ sleepDetailVO.sleepLatency }}分钟</div>
                            </div>
                            <div class="stats-item">
                                <div class="label">深睡时长 </div>
                                <div class="value">{{ sleepDetailVO.deepDuration }}分钟</div>
                            </div>
                            <div class="stats-item">
                                <div class="label">离床次数</div>
                                <div class="value">{{ sleepDetailVO.ambulationNum }}次</div>
                            </div>
                        </div>
                    </div>
                    <div class="part marL">
                        <div class="flex">
                            <div class="title">心率数据</div>
                            <div><span class="fontB">{{ sleepDetailVO.minHr }} - </span><span class="fontB"> {{
                                sleepDetailVO.maxHr }}</span>次/分钟</div>
                        </div>
                        <div class="chart-container marL">
                            <div ref="chart4" id="chart4" style="width:100%;margin-top:20px;height:300px"
                                v-if="hrChart.length > 0"></div>
                            <div v-else class="nodata"> 暂无数据</div>
                        </div>
                    </div>
                </div>
                <div class="flex">
                    <div class="part">
                        <div class="flex" style="margin-top:0">
                            <div class="title">呼吸数据</div>
                            <div>平均<span class="fontB">{{ sleepDetailVO.apneaDurationAverage }}</span>次/分钟</div>
                        </div>
                        <div class="chart-container">
                            <div ref="chart5" id="chart5" style="width:100%;height:200px" v-if="brChart.length > 0">
                            </div>
                            <div v-else class="nodata"> 暂无数据</div>
                        </div>
                    </div>
                    <div class="part marL">
                        <div class="title">呼吸健康</div>
                        <div style="margin-top:10px;">
                            <slider :value="sleepDetailVO.respirationScore" :max="100" :segments="[
                                { label: '需要关注', start: 0, end: 70, color: '#FFB3C1' },
                                { label: '正常', start: 71, end: 85, color: '#B3E5FC' },
                                { label: '优秀', start: 86, end: 100, color: '#81D4FA' }
                            ]"> </slider>
                        </div>
                        <div class="sleep-stats-container">
                            <div class="stats-item">
                                <div class="label">呼吸暂停 </div>
                                <div class="value">{{ sleepDetailVO.apneaNum }}次</div>
                            </div>
                            <div class="stats-item">
                                <div class="label">最长呼吸暂停 </div>
                                <div class="value">{{ sleepDetailVO.apneaDurationMax }}分钟</div>
                            </div>
                            <div class="stats-item">
                                <div class="label">平均呼吸暂停</div>
                                <div class="value">{{ sleepDetailVO.apneaDurationAverage }}分钟</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex">
                    <div class="part">
                        <div class="flex" style="margin-top:0">
                            <div class="title">体动数据</div>
                            <div class="">翻身<span class="fontB">{{ sleepDetailVO.turnOverNum }}</span>次</div>
                        </div>
                        <div class="chart-container">
                            <div ref="chart6" id="chart6" style="width:100%;height:300px"
                                v-if="movementData.length > 0">
                            </div>
                            <div v-else class="nodata"> 暂无数据</div>
                        </div>
                    </div>
                    <div class="part marL">
                        <div class="title">HRV</div>
                        <div style="margin-top:20px">
                            <slider :value="sleepDetailVO.mood" :max="150" :segments="[
                                { label: '焦虑', start: 0, end: 60, color: '#FFB3C1' },
                                { label: '愉悦', start: 61, end: 150, color: '#81D4FA' }
                            ]" />
                        </div>
                        <div class="title" style="margin-top:20px;">心脏健康指数</div>
                        <div style="margin-top:10px;">
                            <slider :value="sleepDetailVO.heartHp" :max="100" :segments="[
                                { label: '需要关注', start: 0, end: 70, color: '#FFB3C1' },
                                { label: '正常', start: 71, end: 85, color: '#B3E5FC' },
                                { label: '优秀', start: 86, end: 100, color: '#81D4FA' }
                            ]"> </slider>
                        </div>
                    </div>
                </div>
                <!-- <div class="flex">
                    <div class="part">
                        <div class="title">心动图</div>
                        <div class="chart-container">
                            <div ref="chart7" id="chart7" style="width:100%;height:300px"></div>
                        </div>
                    </div>
                    <div class="part marL">
                        <div class="title">心脏健康指数</div>
                        <div style="margin-top:60px;">
                            <slider :value="sleepDetailVO.ahi" :max="100" :segments="[
                                { label: '需要关注', start: 0, end: 70, color: '#FFB3C1' },
                                { label: '正常', start: 71, end: 85, color: '#B3E5FC' },
                                { label: '优秀', start: 86, end: 100, color: '#81D4FA' }
                            ]"> </slider>
                        </div>
                    </div>
                </div> -->
                <div class="flex">
                    <div class="part">
                        <div class="title">心脏健康指标</div>
                        <div>
                            <table class="metric-table">
                                <thead>
                                    <tr>
                                        <th>指标</th>
                                        <th>监测值</th>
                                        <th>结果</th>
                                        <th>参考值</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>心率</td>
                                        <td>{{ sleepDetailVO.aveHr }}</td>
                                        <td><span :class="getClass(getResult(sleepDetailVO.aveHr, 45, 70))">{{
                                            getResult(sleepDetailVO.aveHr, 45, 70) }}</span></td>
                                        <td>45-70bpm</td>
                                    </tr>
                                    <tr>
                                        <td><span class="indicator">RR间期<span class="icon"></span></span></td>
                                        <td>{{ sleepDetailVO.rrPeriod ? sleepDetailVO.rrPeriod : '' }}</td>
                                        <td><span :class="getClass(getResult(sleepDetailVO.rrPeriod, 600, 1200))">{{
                                            getResult(sleepDetailVO.rrPeriod, 600, 1200) }}</span></td>
                                        <td>600-1200ms</td>
                                    </tr>
                                    <tr>
                                        <td><span class="indicator">SDNN<span class="icon"></span></span></td>
                                        <td>{{ sleepDetailVO.sdnn ? sleepDetailVO.sdnn : '' }}</td>
                                        <td><span :class="getClass(getResult(sleepDetailVO.sdnn, 111, 175))">{{
                                            getResult(sleepDetailVO.sdnn, 111, 175) }}</span></td>
                                        <td>111-175ms</td>
                                    </tr>
                                    <tr>
                                        <td><span class="indicator">pNN50<span class="icon"></span></span></td>
                                        <td>{{ sleepDetailVO.pnn50 ? sleepDetailVO.pnn50 : '' }}</td>
                                        <td><span :class="getClass(getResult(sleepDetailVO.pnn50, 4, 22))">{{
                                            getResult(sleepDetailVO.pnn50, 4, 22) }}</span></td>
                                        <td>4-22%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="part marL">
                        <div class="title">健康指标</div>
                        <table class="metric-table">
                            <thead>
                                <tr>
                                    <th>指标</th>
                                    <th>监测值</th>
                                    <th>结果</th>
                                    <th>参考值</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- 睡眠总时长：>7小时 → 正常范围 [7, +∞)，所以 min=7, max=Infinity -->
                                <tr>
                                    <td><span class="indicator">睡眠总时长<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.bedDuration / 60 }}</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.bedDuration, 7, Infinity))">
                                            {{ getResult(sleepDetailVO.bedDuration, 7, Infinity) }}
                                        </span>
                                    </td>
                                    <td>&gt;7小时</td>
                                </tr>

                                <!-- 深睡时长：>60分钟 → min=60, max=Infinity -->
                                <tr>
                                    <td><span class="indicator">深睡时长<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.deepDuration }}</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.deepDuration, 60, Infinity))">
                                            {{ getResult(sleepDetailVO.deepDuration, 60, Infinity) }}
                                        </span>
                                    </td>
                                    <td>&gt;60分钟</td>
                                </tr>

                                <!-- 睡眠准备期：<40分钟 → 越小越好，正常范围 [0, 40]，所以 min=0, max=40 -->
                                <tr>
                                    <td><span class="indicator">睡眠准备期<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.sleepLatency }}</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.sleepLatency, 0, 40))">
                                            {{ getResult(sleepDetailVO.sleepLatency, 0, 40) }}
                                        </span>
                                    </td>
                                    <td>&lt;40分钟</td>
                                </tr>

                                <!-- 呼吸暂停：<5次/小时 → min=0, max=5 -->
                                <tr>
                                    <td><span class="indicator">呼吸暂停<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.apneaNum }}次/小时</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.apneaNum, 0, 5))">
                                            {{ getResult(sleepDetailVO.apneaNum, 0, 5) }}
                                        </span>
                                    </td>
                                    <td>&lt;5次/小时</td>
                                </tr>

                                <!-- 平均心率：45-70 → min=45, max=70 -->
                                <tr>
                                    <td><span class="indicator">平均心率<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.aveHr }}</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.aveHr, 45, 70))">
                                            {{ getResult(sleepDetailVO.aveHr, 45, 70) }}
                                        </span>
                                    </td>
                                    <td>45-70bpm</td>
                                </tr>

                                <!-- 最低心率：≥35 → 正常范围 [35, +∞) -->
                                <tr>
                                    <td><span class="indicator">最低心率<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.minHr }}</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.minHr, 35, Infinity))">
                                            {{ getResult(sleepDetailVO.minHr, 35, Infinity) }}
                                        </span>
                                    </td>
                                    <td>≥35bpm</td>
                                </tr>

                                <!-- 最高心率：≤80 → 正常范围 [0, 80] -->
                                <tr>
                                    <td><span class="indicator">最高心率<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.maxHr }}</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.maxHr, 0, 80))">
                                            {{ getResult(sleepDetailVO.maxHr, 0, 80) }}
                                        </span>
                                    </td>
                                    <td>≤80bpm</td>
                                </tr>

                                <!-- 平均呼吸率：12-18 → min=12, max=18 -->
                                <tr>
                                    <td><span class="indicator">平均呼吸率<span class="icon"></span></span></td>
                                    <td>{{ sleepDetailVO.aveBr }}</td>
                                    <td>
                                        <span :class="getClass(getResult(sleepDetailVO.aveBr, 12, 18))">
                                            {{ getResult(sleepDetailVO.aveBr, 12, 18) }}
                                        </span>
                                    </td>
                                    <td>12-18次</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="action-buttons">
                    <el-button type="info" @click="handleCancel" size="small" class="cancel-btn">
                        取消
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from "echarts"
import slider from "./slider.vue";
export default {
    components: { slider },
    name: 'SleepReportDetail',
    props: {
        detailInfo: {
            type: Object,
            required: true
        },
        isDialog: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            time: '',
            searchForm: '',
            sleepDetailVO: {},
            chart1: null,
            chart2: null,
            chart3: null,
            chart4: null,
            chart5: null,
            chart6: null,
            chart7: null,
            hrChart: [],
            brChart: [],
            movementData: []
        }
    },
    computed: {
        detail() {
            return this.detailInfo;
        },
        currentLabel() {
            if (this.value <= 70) return '需要关注';
            if (this.value <= 85) return '正常';
            return '优秀';
        },
        hasSleepData() {
            return Array.isArray(this.sleepData) && this.sleepData.length > 0;
        }
    },
    watch: {
        detailInfo: {
            handler(val) {
                this.sleepDetailVO = val.sleepDetailVO
                this.hrChart = val.hrChart
                this.brChart = val.brChart
                this.sleepData = val.sleepStageDistribution
                this.movementData = val.movingChart
                this.getChart1()
                this.getChart2()
                this.getChart3()
                this.getChart4()
                this.getChart5()
                this.getChart6()
            },
            deep: true,
        }
    },
    methods: {
        getResult(value, minRef, maxRef) {
            if (value == null || value === '' || isNaN(Number(value))) {
                return '';
            }
            const num = parseFloat(value);
            if (num < minRef) return '↓';
            if (num > maxRef) return '↑';
            return '正常';
        },

        // 根据 getResult 返回的文本，决定样式类
        getClass(resultText) {
            if (resultText === '↑') return 'result-high';
            if (resultText === '↓') return 'result-low';
            return 'result-normal';
        },
        // 格式化JSON显示
        formatJsonDisplay(data) {
            try {
                // 如果是字符串且可能是JSON，尝试解析
                if (typeof data === 'string') {
                    const parsed = JSON.parse(data);
                    return JSON.stringify(parsed, null, 2);
                }
                // 如果是对象，直接格式化
                return JSON.stringify(data, null, 2);
            } catch (e) {
                // 如果不是JSON，直接显示原始数据
                return data;
            }
        },
        async getChart1() {
            const chartDom = document.getElementById('chart1');
            if (!chartDom) return;
            this.chart1 = echarts.init(chartDom);
            const max = 100;
            const value = this.sleepDetailVO.sleepScore || 0;
            const qualityDesc = this.sleepDetailVO.sleepQualityDesc || '正常';
            const option = {
                title: [{
                    text: '',
                    bottom: '300',
                    x: 'center',
                    padding: [7, 14],
                    textStyle: {
                        fontWeight: 'normal',
                        fontSize: 12,
                        color: '#fff'
                    }
                }],
                angleAxis: {
                    show: false,
                    max: 100 * 360 / 270, //-45度到225度，二者偏移值是270度除360度
                    type: 'value',
                    startAngle: 225, //极坐标初始角度
                    splitLine: {
                        show: false
                    }
                },
                barMaxWidth: 14, //圆环宽度
                radiusAxis: {
                    show: false,
                    type: 'category',
                },
                //圆环位置和大小
                polar: {
                    center: ['50%', '50%'],
                    radius: '180'
                },
                series: [{
                    type: 'bar',
                    data: [{ //上层圆环，显示数据
                        value: value,
                        itemStyle: {
                            color: { //图形渐变颜色方法，四个数字分别代表，右，下，左，上，offset表示0%到100%
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1, //从左到右 0-1
                                y2: 0,
                                colorStops: [{
                                    offset: 0,
                                    color: '#67c0f2'
                                }, {
                                    offset: 1,
                                    color: '#67c0f2'
                                }],
                            },
                        },
                    }],
                    barGap: '-100%', //柱间距离,上下两层圆环重合
                    coordinateSystem: 'polar',
                    roundCap: true, //顶端圆角从 v4.5.0 开始支持
                    z: 2 //圆环层级，同zindex
                },
                { //下层圆环，显示最大值
                    type: 'bar',
                    data: [{
                        value: 100,
                        itemStyle: {
                            color: '#D0E8FF'
                        }
                    }],
                    barGap: '-100%',
                    coordinateSystem: 'polar',
                    roundCap: true,
                    z: 1
                },
                //仪表盘
                {
                    name: 'AQI',
                    type: 'gauge',
                    startAngle: 225, //起始角度，同极坐标
                    endAngle: -45, //终止角度，同极坐标
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLabel: {
                        show: false
                    },
                    pointer: {
                        show: false
                    },
                    title: {
                        offsetCenter: [0, -10],
                        color: '#333',
                        fontSize: 60,
                        fontWeight: 500,
                        rich: {
                            a: {
                                fontWeight: 'normal',
                                fontSize: 16,
                                color: '#333',
                                padding: [0, 0, 10, 0]
                            }
                        }
                    },
                    detail: {
                        show: false,
                        color: '#333',
                        fontSize: 16,
                        offsetCenter: [40, -15],
                        backgroundColor: '#fff',
                        borderRadius: 8,
                        padding: [4, 12],
                    },
                    data: [{
                        value: value,
                        name: value + '\n' + '{a|' + qualityDesc + '}'
                    }]
                }
                ]
            }
            this.chart1.setOption(option, true);
        },
        formatTime(time) {
            const minutes = time.getMinutes();
            const minStr = minutes < 10 ? '0' + minutes : minutes;
            return time.getHours() + ':' + minStr;
        },
        formater(v) {
            if (v == "0") return '深睡期';
            if (v == "1") return '浅睡期';
            if (v == "2") return '快速眼动期'; // ✅ 修正这里
            if (v == "3") return '清醒期';
            return '';
        },
        randomNum(n) {
            var res = [];
            for (var i = 0; i < n; i++) {
                res.push(Math.ceil(Math.random() * 5));
            }
            return res;
        },
        getChart2() {
            this.$nextTick(() => {
                const chartDom = document.getElementById('chart2');
                if (!chartDom) return;
                this.chart2 = echarts.init(chartDom);
                const sleepStages = this.sleepDetailVO.sleepStages;
                let minTime = Infinity;
                let maxTime = -Infinity;
                for (let item of sleepStages) {
                    const startSec = Math.floor(new Date(item.startTime).getTime() / 1000);
                    const endSec = Math.floor(new Date(item.endTime).getTime() / 1000);
                    minTime = Math.min(minTime, startSec);
                    maxTime = Math.max(maxTime, endSec);
                }

                const totalMinutes = Math.ceil((maxTime - minTime) / 60);
                const timeData = [];
                const stack = [];      // Y轴位置: 0=深睡, 1=浅睡, 2=REM, 3=清醒
                const demodata = [];

                // 颜色映射（按你的原始逻辑）
                const getColor = (stageType) => {
                    if (stageType === 1) return '#c3ad93';   // 清醒
                    if (stageType === 2) return '#dfdfdf';   // 快速眼动
                    if (stageType === 3) return '#abdded';   // 浅睡
                    if (stageType === 4) return '#6bbef2';   // 深睡
                    return '#ccc';
                };

                // 逐分钟采样
                for (let i = 0; i < totalMinutes; i++) {
                    const currentSec = minTime + i * 60;
                    let matchedStage = 1; // 默认清醒

                    // 查找覆盖当前分钟的阶段
                    for (let item of sleepStages) {
                        const startSec = Math.floor(new Date(item.startTime).getTime() / 1000);
                        const endSec = Math.floor(new Date(item.endTime).getTime() / 1000);
                        if (currentSec < endSec && currentSec + 60 > startSec) {
                            matchedStage = item.stageType;
                            break;
                        }
                    }

                    // --- timeData ---
                    const time = new Date(currentSec * 1000);
                    timeData.push(`${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}`);

                    // --- stack: stageType → yIndex ---
                    let yIndex;
                    if (matchedStage === 4) yIndex = 0; // 深睡期 → 0
                    else if (matchedStage === 3) yIndex = 1; // 浅睡期 → 1
                    else if (matchedStage === 2) yIndex = 2; // 快速眼动期 → 2
                    else yIndex = 3; // 清醒期 → 3

                    stack.push(yIndex);

                    // --- demodata ---
                    const color = getColor(matchedStage);
                    demodata.push({
                        value: 1,
                        itemStyle: {
                            color: color,
                            borderColor: color
                        }
                    });
                }
                let that = this
                const option = {
                    tooltip: {
                        show: true,
                        trigger: 'item',
                        formatter: (params) => {
                            const index = params.dataIndex; // 当前柱子的索引（分钟序号）
                            const timeLabel = timeData[index]; // 如 "22:30"
                            const nextTime = timeData[index + 1] ||
                                (new Date(new Date(timeData[index]).getTime() + 60 * 1000))
                                    .toTimeString().slice(0, 5); // 下一分钟，或+1分钟

                            // 从 stack 获取 Y 轴值（0~3）
                            const yValue = stack[index];
                            const stageName = that.formater(String(yValue)); // 调用你的 formatter

                            return `${stageName}<br/>${timeLabel} - ${nextTime}`;
                        }
                    },
                    //你的代码
                    legend: {
                        show: false
                    },
                    grid: [
                        { left: '4%', top: '5%', bottom: '2%', containLabel: "true" },
                    ],
                    xAxis: [
                        {
                            gridIndex: 0, splitLine: { show: false }, data: timeData,
                            axisLabel: {
                                align: 'center',
                                showMinLabel: true,
                                showMaxLabel: true,
                                margin: 15,
                            },
                            axisLine: {
                                show: false,
                            },
                            axisTick: {
                                show: false,
                            },
                        },
                    ],
                    yAxis: [
                        {
                            min: 0, max: 4,
                            axisLabel: {
                                textStyle: {
                                    // color: 'rgba(255,255,255,0.40)',
                                    fontSize: 12,
                                },
                                verticalAlign: 'top',
                                padding: [-25, 0, 0, 0],
                                formatter: function (parmas) {
                                    console.log(that.formater(parmas), 'that.formater(parmas)')
                                    return that.formater(parmas)
                                }
                            },
                            splitLine: {
                                show: true,
                            },
                            axisLine: {
                                show: false,
                            },
                            axisTick: {
                                show: false,
                            },
                        },
                    ],

                    series: [
                        {
                            name: '',
                            type: 'bar',
                            xAxisIndex: 0,
                            yAxisIndex: 0,
                            data: stack,
                            stack: 'ad',
                            tooltip: {
                                show: false
                            },
                            itemStyle: {
                                color: "rgba(0,0,0,0)",
                                borderColor: "rgba(0,0,0,0)",
                            }
                        },
                        {
                            name: '睡眠数据',
                            type: 'bar',
                            xAxisIndex: 0,
                            yAxisIndex: 0,
                            data: demodata,
                            stack: 'ad',
                            // barWidth: "100%",
                        },
                    ],
                }
                this.chart2.setOption(option, true);
            })
        },
        getChart3() {
            this.$nextTick(() => {
                let colors = ['#ade1f6', '#78bee6', '#dedede', '#e0a160']
                const chartDom = document.getElementById('chart3');
                if (!chartDom) return;
                this.chart3 = echarts.init(chartDom);
                const seriesData = Object.keys(this.sleepData).map(key => ({
                    name: `${key}: ${this.sleepData[key].toFixed(2)}%`,
                    value: this.sleepData[key],
                    itemStyle: {
                        color: colors[key]
                    }
                }));
                const option = {
                    color: colors,
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}'
                    },
                    legend: {
                        show: true,
                        orient: 'vertical',
                        right: '10%',
                        top: 'middle',
                        itemWidth: 10,
                        itemHeight: 10,
                        textStyle: {
                            fontSize: 12,
                            color: '#333'
                        },
                        formatter: function (name) {
                            // 返回原样，因为 name 已经包含百分比
                            return name;
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['50%', '70%'], // 环形图
                            avoidLabelOverlap: false,
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            data: seriesData,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                }
                this.chart3.setOption(option, true);
            })
        },
        getChart4() {
            this.$nextTick(() => {
                const data = this.hrChart || [];
                const chartDom = document.getElementById('chart4');
                if (!chartDom) return;
                this.chart4 = echarts.init(chartDom);
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        data: data.map(d => d.hour),
                        axisLabel: {
                          //  interval: 0,
                        },
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: { show: false }
                    },
                    series: [{
                        name: '心率数据',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            color: '#89b8ca'
                        },
                        data: data.map(d => Number(d.avgHr)), // 确保是 number 类型
                        symbol: 'none'
                    }]
                };
                this.chart4.setOption(option, true);
            })
        },
        getChart5() {
            this.$nextTick(() => {
                const data = this.brChart || [];
                const chartDom = document.getElementById('chart5');
                if (!chartDom) return;
                this.chart5 = echarts.init(chartDom);
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        data: data.map(d => d.hour),
                        axisLabel: {
                          //  interval: 0,
                        },
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: { show: false }
                    },
                    grid: {
                        top: '10%',
                        bottom: '15%'
                    },
                    series: [{
                        name: '呼吸数据',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            color: '#89b8ca'
                        },
                        data: data.map(d => Number(d.avgBr)), // 确保是 number 类型
                        symbol: 'none'
                    }]
                };
                this.chart5.setOption(option, true);
            })
        },
        getChart6() {
            this.$nextTick(()=>{
              const chartDom = document.getElementById('chart6');
            if (!chartDom) return;
            this.chart6 = echarts.init(chartDom);
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: (params) => {
                        const point = params[0];
                        return `${point.name}: ${point.value}`;
                    }
                },
                xAxis: {
                    type: 'category',
                    data: this.movementData.map(d => d.hour),
                    axisLabel: {
                        color: '#666',
                        fontSize: 12,
                       // interval: 0,
                    },
                    axisLine: {
                        show: true
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                    axisLine: {
                        show: true
                    },
                    axisTick: {
                        show: false
                    }
                },
                series: [
                    {
                        name: '体动',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            color: '#25B4D5',
                            width: 2
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(37, 180, 213, 0.1)' },
                                { offset: 1, color: 'rgba(37, 180, 213, 0.05)' }
                            ])
                        },
                        data: this.movementData.map(d => d.movingCount),
                        symbol: 'none'
                    },
                    {
                        name: '翻身',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            color: '#E91E63',
                            width: 2
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(233, 30, 99, 0.1)' },
                                { offset: 1, color: 'rgba(233, 30, 99, 0.05)' }
                            ])
                        },
                        data: this.movementData.map(d => d.turnoverCount),
                        symbol: 'none'
                    }
                ],
                legend: {
                    show: true,
                    bottom: '0%',
                    left: 'center',
                    textStyle: {
                        fontSize: 12,
                        color: '#666'
                    },
                    itemWidth: 12,
                    itemHeight: 12
                },
                grid: {
                    left: '15%',
                    right: '15%',
                    bottom: '15%',
                    top: '15%'
                }
            }
            this.chart6.setOption(option, true);
            })
        },
        handleCancel() {
            this.$emit('closeDialog');
        }
    }
}
</script>

<style lang="less" scoped>
.fontB {
    font-size: 20px;
    font-weight: bold;
}

.nodata {
    text-align: center;
    color: #333;
    font-size: 18px;
    margin-top: 70px;
}

.detail-container {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-height: 80vh;
    overflow-y: auto;
}

.detail-container h2 {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.detail-container p {
    margin: 8px 0;
    line-height: 1.6;
}

.detail-container strong {
    color: #333;
    font-weight: 600;
}

.metric-table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 14px;
    color: #333;
}

.metric-table th {
    background-color: #f5f5f5;
    padding: 10px;
    text-align: center;
    border-bottom: 1px solid #ddd;
    font-weight: normal;
    color: #555;
}

.metric-table td {
    padding: 10px;
    border-bottom: 1px solid #eee;
    text-align: center;
}

.metric-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.metric-table tr:hover {
    background-color: #f0f7ff;
}

.metric-table .indicator {
    color: #409eff;
    font-size: 14px;
    cursor: pointer;
}

.metric-table .result-high {
    color: #e6a23c;
    font-weight: bold;
}

.metric-table .result-normal {
    color: #67c23a;
    font-weight: bold;
}

.metric-table .result-low {
    color: #f56c6c;
    font-weight: bold;
}

.metric-table .icon {
    font-size: 12px;
    margin-left: 4px;
    color: #999;
}

.code-block {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    overflow-x: auto;
    margin-top: 5px;
    white-space: pre-wrap;
    word-break: break-all;
    max-height: 200px;
    overflow-y: auto;
}

.action-buttons {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
    text-align: right;
}

.cancel-btn {
    margin-right: 10px;
}

.flex {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .marL {
        padding-left: 40px;
    }

    .quity {
        color: #67bef7;
        font-size: 16px;
    }

    .part {
        flex: 1;
        .title {
            color: #333;
            font-size: 18px;
        }
    }
}

.content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;

    .left-info,
    .right-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 20px;
    }

    .info-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        font-size: 0.9rem;
        color: #555;
        white-space: nowrap;
        margin-top: 20px;
    }

    .info-item .icon {
        font-size: 1.2rem;
        color: #5B9AF2;
    }

    .info-item .value {
        font-weight: bold;
        color: #333;
    }

    .chart-container {
        position: relative;
        width: 200px;
        height: 200px;
        margin: 0 auto;
    }

    .chart {
        width: 100%;
        height: 100%;
    }

    .center-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, 50%);
        font-size: 1rem;
        color: #666;
        text-align: center;
        pointer-events: none;
    }
}

.sleep-stats-container {
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 16px 12px;
    margin-top: 16px;

    .stats-item {
        flex: 1;
        text-align: center;
        padding: 0 8px;
        position: relative;
    }

    .stats-item:not(:last-child)::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: #eee;
    }

    .label {
        font-size: 12px;
        color: #666;
        line-height: 1.4;
        margin-bottom: 4px;
    }

    .icon {
        font-size: 10px;
        color: #999;
        margin-left: 4px;
    }

    .value {
        font-size: 18px;
        font-weight: 500;
        color: #333;
    }
}

.score-slider-container {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
</style>